import { useEffect, useRef, useState } from "react";
import { signal } from "@preact/signals-react";
import { useLocation } from "react-router";
import { insertRecord } from "storev2/formStore";

export function useAutoOpen(layout) {
  const location = useLocation();
  const initialized = useRef(false);

  const [config] = useState(() => {
    if (!layout) return null;
    const params = new URLSearchParams(location.search);
    const id = params.get("id");
    if (!id) return null;
    return {
      id: parseInt(id),
      modalRecordStoreId: signal(null),
      openModal: signal(false),
    };
  });

  useEffect(() => {
    if (!config || initialized.current) return;
    initialized.current = true;
    (async () => {
      try {
        const storeId = await insertRecord(
          config.id,
          layout.model,
          layout,
        );
        if (storeId) {
          config.modalRecordStoreId.value = storeId;
          config.openModal.value = true;
        }
      } catch (err) {
        console.error("[useAutoOpen] error:", err);
      }
    })();
  }, []);

  if (!config) return null;
  return {
    modalRecordStoreId: config.modalRecordStoreId,
    openModal: config.openModal,
  };
}
